<div class="flex items-center justify-center">

    <div class="routed-content justify-center items-center flex flex-col w-full" #routedContainer>
        <div class="flex gap-2 items-center w-100">
            <a [routerLink]="['/employees']" class="back-button flex items-center justify-center gap-2 no-decoration">
                <i class="material-icons">arrow_back</i>
                <span>Back</span>
            </a>
            <h2 class="w-70 center-text">Add New Employee</h2>
        </div>
        <form class="w-100" #form="ngForm" (ngSubmit)="saveEmployee(form)">
            <div class="input-group">
                <label for="email">Email Address <span class="required-indicator">*</span></label>
                <input required type="text" (blur)="checkEmail()" [(ngModel)]="newEmployee.user_email" id="email" name="user_email"
                    class="textbox p-10">
                <div *ngIf="form.submitted && form.controls.user_email?.invalid">
                    <small class="error-message">Email is required</small>
                </div>
                <div>
                    <small *ngIf="emailMsg" class="sm-mt d-block" [class]="emailMsg.includes('available') ? 'success-message-plain': 'error-message'">{{ emailMsg }}</small>
                </div>

            </div>

            <div class="flex gap-2 w-100">
                <div class="input-group">
                    <label for="fn">First Name <span class="required-indicator">*</span></label>
                    <input type="text" [(ngModel)]="newEmployee.first_name" id="fn" required name="first_name"
                        class="textbox p-10">
                    <div *ngIf="form.submitted && form.controls.first_name?.invalid">
                        <small class="error-message">First Name is required</small>
                    </div>
                </div>

                <div class="input-group">
                    <label for="ln">Last Name <span class="required-indicator">*</span></label>
                    <input type="text" [(ngModel)]="newEmployee.last_name" id="ln" required name="last_name"
                        class="textbox p-10">
                    <div *ngIf="form.submitted && form.controls.last_name?.invalid">
                        <small class="error-message">Last Name is required</small>
                    </div>
                </div>
            </div>

            <div class="flex gap-2 w-100">
                <div class="input-group">
                    <label for="lfn">Legal First Name</label>
                    <input type="text" [(ngModel)]="newEmployee.legal_first_name" id="lfn" name="legal_first_name"
                        class="textbox p-10">
                </div>

                <div class="input-group">
                    <label for="lln">Legal Last Name</label>
                    <input type="text" [(ngModel)]="newEmployee.legal_last_name" id="lln" name="legal_last_name"
                        class="textbox p-10">
                </div>
            </div>

            <div class="input-group">
                <label for="phone">Phone Number</label>
                <input type="text" [maxlength]="13" [(ngModel)]="newEmployee.phone" id="phone" name="phone"
                    class="textbox p-10">
            </div>

            <div class="label-divider w-100">
                <span class="divider-line"></span>
                <p class="label">Address</p>
                <span class="divider-line"></span>
            </div>


            <div class="input-group">
                <label for="address_1">Address Line 1</label>
                <input type="text" [(ngModel)]="newEmployee.address_1" id="address_1" name="address_1"
                    class="textbox p-10">
            </div>

            <div class="input-group">
                <label for="address_2">Address Line 2</label>
                <input type="text" [(ngModel)]="newEmployee.address_2" id="address_2" name="address_2"
                    class="textbox p-10">
            </div>

            <div class="input-group">
                <label for="city">City</label>
                <input type="text" [(ngModel)]="newEmployee.city" id="city" name="city" class="textbox p-10">
                <div *ngIf="form.submitted && form.controls.city?.invalid">
                    <small class="error-message">City is required</small>
                </div>
            </div>

            <div class="flex gap-2 w-100">
                <div class="input-group">
                    <label for="state">State</label>
                    <input type="text" [maxlength]="2" [(ngModel)]="newEmployee.state" name="state" id="state"
                        class="textbox p-10">
                    <div *ngIf="form.submitted && form.controls.state?.invalid">
                        <small class="error-message">State is required</small>
                    </div>
                </div>
                <div class="input-group">
                    <label for="zip">ZIP Code</label>
                    <input type="tel" [(ngModel)]="newEmployee.zip_code" id="zip" name="zip_code" class="textbox p-10">

                </div>
            </div>

            <div class="label-divider w-100">
                <span class="divider-line"></span>
                <p class="label">Others</p>
                <span class="divider-line"></span>
            </div>

            <div class="input-group">
              <label for="position">Position <span class="required-indicator">*</span></label>
              <select class="textbox p-10" id="position" name="type" required [(ngModel)]="newEmployee.employee_type">
                <option value="Quizmaster">Quizmaster</option>
                <option value="Writer">Writer</option>
                <option value="Office">Office Staff</option>
              </select>
              <div *ngIf="form.submitted && form.controls.type?.invalid">
                <small class="error-message">Position is required</small>
              </div>
            </div>

            <div class="flex gap-2 w-100">
                <div class="input-group">
                    <label for="qmrate">Quizmaster Rate</label>
                    <input type="number" [(ngModel)]="newEmployee.QM_rate" id="qmrate" name="QM_rate"
                        class="textbox p-10">
                </div>

                <div class="input-group">
                    <label for="hourlyrate">Hourly Rate</label>
                    <input type="number" [(ngModel)]="newEmployee.hourly_rate" name="hourly_rate" id="hourlyrate"
                        class="textbox p-10">
                </div>
            </div>

            <div class="input-group">
                <label for="contractor">
                    <input type="checkbox" [(ngModel)]="newEmployee.contractor" name="contractor" id="contractor"
                        class="textbox p-10">
                    Contractor</label>
            </div>

            <p class="success-message" *ngIf="successMessage !== ''">{{ successMessage }}</p>
            <button type="submit" class="back-button w-100 save-button">
                {{ isSavingInfo ? 'Saving...': 'Save Employee' }}
            </button>
        </form>
    </div>
</div>
